import { render, staticRenderFns } from "./HeaderContact.vue?vue&type=template&id=927b8d12&scoped=true&"
import script from "./HeaderContact.vue?vue&type=script&lang=js&"
export * from "./HeaderContact.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContact.vue?vue&type=style&index=0&id=927b8d12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927b8d12",
  null
  
)

export default component.exports